<div>
  @if(inputsToConfigure !== undefined) {
    <div
      class="input-group-container"
      [class.disabled]="task?.started"
      >
      <!-- "normal visibility inputs" (vs advanced ones further below) -->
      @for (group of inputsToConfigure.basicGroups; track group) {
        <div class="inputs-group">
          @if((group.groupName?.length ?? 0) > 0) {
            @if(readonly) {
              <b class="mb-2">{{ group.groupName }}</b>
            } @else {
              <h4>{{ group.groupName }}</h4>
            }
          }
          <div class="inputs-container-wrapper">
            @for (wrapper of group.groupInputs; track wrapper) {
              @if(wrapper.displayConditionsMet) {
                <div class="inputs-container">
                  <ng-container *ngTemplateOutlet="inputTemplate; context: { wrapper, advanced: false}"></ng-container>
                </div>
              }
            }
          </div>
        </div>
      }

      <!-- Toggle, which, when enabled, makes advanced inputs become visible -->

      @if(hasAdvancedInputs && inputsToConfigure!.displayAdvancedGroups) {
        <div>
          <mat-slide-toggle
          class="mb-3"
          (change)="advancedOptionsToggled($event)"
          [checked]="advancedOptionsEnabled">
            <span>Advanced settings</span>
          </mat-slide-toggle>
        </div>
      }
    </div>
  }

  @if(hasAdvancedInputs && advancedOptionsEnabled) {
    @for (group of inputsToConfigure!.advancedGroups!; track group) {
      <div class="inputs-group">
        <!-- Current group's name -->
        @if((group.groupName?.length ?? 0) > 0) {
          @if(readonly) {
            <b class="mb-2">{{ group.groupName }}</b>
          } @else {
            <h4>{{ group.groupName }}</h4>
          }
        }
        <!-- Inputs of the current group -->
        <div class="inputs-container-wrapper">
          @for (wrapper of group.groupInputs; track wrapper) {
            @if(wrapper.displayConditionsMet) {
              <div class="inputs-container">
                <ng-container *ngTemplateOutlet="inputTemplate; context: { wrapper, advanced: true }"></ng-container>
              </div>
            }
          }
        </div>
      </div>
    }
  }

  <!-- "No inputs"-message --->
  @if(inputsToConfigure !== undefined && inputsToConfigure.basicGroups.length === 0 && inputsToConfigure.advancedGroups.length === 0) {
    <div>
      <p>
        This task does not contain any inputs.
      </p>
    </div>
  }

</div>

<!-- The template used to display the correct types of inputs for the task -->
<ng-template #inputTemplate let-wrapper="wrapper" let-showAdvanced="advanced">
  @if (showAdvanced === (wrapper.input.item.visibility === 'advanced')) {
    @if ({
      requireOverride: inputValueDiff[wrapper.key] !== undefined,
      overrideDefaultValue: inputValueDiff[wrapper.key]?.value,
      overrideConfirmed: wrapper.input.value === null,
      disabled: taskHasBeenStarted || wrapper.input.disabled
      }; as info) {
      @if (wrapper.input.source !== 'reassignable' && (wrapper.input.inputElementType !== 'lisprofile-generator' && wrapper.input.inputElementType !== 'shaker-control')) {
        <app-usersetting-input
          [readonly]="readonly"
          [input]="wrapper.input"
          [requireOverride]="info.requireOverride"
          [overrideDefaultValue]="info.overrideDefaultValue"
          [userTemplateList]="
            wrapper.input.inputElementType === 'table' ? liquidTypeTemplateList() :
            wrapper.input.inputElementType === 'pH-calibration' ? pHCalibrationList :
            wrapper.input.inputElementType === 'DO-calibration' ? DOCalibrationList :
            undefined
          "
          [thingie]="(contextThingie$ | async) ?? undefined"
          [processIdx]="processIdx"
          [taskIdx]="taskIdx"
          (valueChanged)="_onInputUpdated(wrapper)"
          [ngClass]="{
            'hide-setting': wrapper.input.item.visibility === 'advanced' && !advancedOptionsEnabled
          }"
          [disabled]="info.disabled"
          [hintProxyNameToSeriesSelector]="hintProxyNameToSeriesSelector"
          [highlightFirstReplicateInSeriesSelector]="highlightFirstReplicateInSeriesSelector"
        />
      }
      <!-- LIS-profile generator - shown only for LIS-including-templates-->
      @if (wrapper.input.source !== 'reassignable' && wrapper.input.inputElementType === 'lisprofile-generator') {
        <div class="lis-overview-container"
          id="lis-overview"
          >
          @if (readonly === false) {
            <mat-form-field
              class="template-selection"
              matTooltip="LIS-Template selection"
              >
              @if (lisTemplateList().length > 0) {
                <mat-label>
                  Feeding Profile
                </mat-label>
              }
              @if (lisTemplateList().length === 0) {
                <mat-label>
                  No feeding profiles available
                </mat-label>
              }
              <mat-select
                (selectionChange)="onFeedingProfileChange($event.value, wrapper.key)"
                [value]="selectedFeedingProfile"
                [disabled]="lisTemplateList().length === 0 || ((wrapper.key | pureFnCall:_inputRequiresOverride) && !lisProfileOverrideConfirmed) || taskHasBeenStarted"
                >
                <mat-option [value]="customFeedingProfileName">
                  Custom Profile
                </mat-option>
                @for (templateName of lisTemplateList(); track templateName) {
                  <mat-option
                    [value]="templateName._id"
                    >
                    {{ templateName.template.name }}
                  </mat-option>
                }
              </mat-select>
              @if ((wrapper.key | pureFnCall:_inputRequiresOverride) && !lisProfileOverrideConfirmed && !taskHasBeenStarted) {
                <mat-hint>
                  Changes will overwrite replicate configurations.&nbsp;
                  <a href="#" (click)="
                    $event.preventDefault();
                    _confirmLisProfileOverride(wrapper.key)
                    "
                    >
                    Continue.
                  </a>
                </mat-hint>
              }
            </mat-form-field>
          }
          @if (readonly === true) {
            <span>
              @if (readonly === true) {
                <span
                  class="basic-label"
                  [matTooltip]="wrapper.input.item.valueInfo[0].description"
                  >
                  {{ wrapper.input.name }}
                  @if ((wrapper.input.item.valueInfo[0]?.unit?.length ?? 0) > 0) {
                    <span>
                      &nbsp;[{{ wrapper.input.item.valueInfo[0]?.unit }}]
                    </span>
                  }
                </span>
              }
              <div>
                <span>
                  Selected profile:
                  {{ { id: wrapper.input.templateId, templates: lisTemplateList() } | pureFnCall:getLisTemplateNameById }}
                </span>
              </div>
            </span>
          }
          <div
            class="chart-wrapper"
            #lisGeneratorPlotContainer
            [class.invalid-element-border]="!feedingProfileValid"
            >
            <plotly-plot
              #lisGeneratorPlot
              [useResizeHandler]="false"
              [data]="[traceForPlotly]"
              [layout]="layout"
              [config]="plotlyConfig"
              [class.disabled]="task?.started"
              >
            </plotly-plot>
          </div>
          @if (loadingData) {
            <app-loading-overlay [targetElement]="lisGeneratorPlotContainer" [borderSize]="8">
              <app-spinner size="lg"></app-spinner>
            </app-loading-overlay>
          }
          <div class="button-row mt-2">
            <div>
              @if (readonly === false) {
                <button
                  mat-raised-button
                  color="primary"
                  (click)="_openLisGenerator(wrapper, readonly)"
                  [disabled]="(wrapper.key | pureFnCall:_inputRequiresOverride) && !lisProfileOverrideConfirmed || taskHasBeenStarted"
                  >
                  Edit Profile
                </button>
              }
              @if (readonly === true) {
                <button
                  mat-stroked-button
                  (click)="_openLisGenerator(wrapper, readonly)"
                  >
                  Show profile details
                </button>
              }
            </div>
          </div>
        </div>
      }
      @if (wrapper.input.source === 'reassignable' && wrapper.input.inputElementType === 'series-selector') {
        <div [matTooltip]="wrapper.input.item.valueInfo[0].description">
          @let formControl = reassignableSeriesFormControls[wrapper.key];
          @if (readonly === false) {
            <!-- Header -->
            <div>{{ wrapper.input.name ?? 'Select series'}}</div>

            <!-- Button and series name -->
            @let disabled = taskHasBeenStarted || (info.requireOverride && !info.overrideConfirmed);
            <div class="grid grid-cols-[auto_minmax(0,1fr)] gap-x-2">
              <button
                class="flex-none mb-[3.5px]"
                mat-raised-button
                color="primary"
                [disabled]="disabled"
                (click)="openSeriesSelector(wrapper, true)">
                Select series
              </button>

              <div 
                class="min-w-0 h-10 flex items-center pl-1 cursor-pointer box-border bg-white border border-solid border-gray-80 rounded-[2px]"
                [class.!border-errorRed-50]="formControl.touched && formControl.invalid"
                (click)="onSeriesValueClick($event, wrapper, disabled)"
              >
                @if (formControl.value) {
                  <span>{{ formControl.value }}</span>
                } @else {
                  <span class="text-gray-70 italic text-[14px]">Select series</span>
                }
              </div>
              <!-- Hint/Error row -->
              <div 
                class="
                  col-start-2
                  [font-size:var(--mat-form-field-subscript-text-size,var(--mat-sys-body-small-size))] 
                  [line-height:var(--mat-form-field-subscript-text-line-height,var(--mat-sys-body-small-line-height))] 
                  [min-height:var(--mat-form-field-subscript-text-min-height,var(--mat-sys-body-small-line-height))]
                "
              >
                @if (formControl.touched && formControl.invalid && formControl.errors?.required) {
                  <mat-error>
                    Series is required.
                  </mat-error>
                }
                @if (formControl.touched && formControl.invalid && formControl.errors?.seriesDisabled) {
                  <mat-error>
                    The selected series is no longer available.
                  </mat-error>
                }
                @if (info.requireOverride && !info.overrideConfirmed && !info.disabled) {
                  <mat-hint>
                    {{ overrideHintText }}&nbsp;
                    <a href="#" (click)="$event.preventDefault(); wrapper.input.value = info.overrideDefaultValue; info.overrideConfirmed = true; _onSeriesSelection(wrapper)">Continue.</a>
                  </mat-hint>
                }
              </div>
            </div>
          } @else {
            <span
              class="basic-label"
              [matTooltip]="wrapper.input.item.valueInfo[0].description"
              >
              {{ wrapper.input.name }}
              @if ((wrapper.input.item.valueInfo[0]?.unit?.length ?? 0) > 0) {
                <span>
                  &nbsp;[{{ wrapper.input.item.valueInfo[0]?.unit }}]
                </span>
              }
            </span>
            <div><span>{{ formControl.value }}</span></div>
          }
        </div>
      }
      @if (wrapper.input.source === 'reassignable' && wrapper.input.inputElementType === 'select') {
        <div>
          <app-usersetting-input
            [input]="wrapper.input"
            [thingie]="(contextThingie$ | async) ?? undefined"
            [processIdx]="processIdx"
            [taskIdx]="taskIdx"
            [requireOverride]="inputValueDiff[wrapper.key] !== undefined"
            [overrideDefaultValue]="inputValueDiff[wrapper.key]?.value"
            (valueChanged)="_onSeriesSelection(wrapper)"
            [ngClass]="{
              'hide-setting': wrapper.input.item.visibility === 'advanced' && !advancedOptionsEnabled
            }"
            [disabled]="taskHasBeenStarted"
            [readonly]="readonly"
            [hintProxyNameToSeriesSelector]="hintProxyNameToSeriesSelector"
            [highlightFirstReplicateInSeriesSelector]="highlightFirstReplicateInSeriesSelector" />

        </div>
      }
      <!-- Shaker control profile -->
      <!-- Shaker-profile generator - shown only for templates with shakers -->
      @if (wrapper.input.source !== 'reassignable' && wrapper.input.inputElementType === 'shaker-control') {
        <div
          class="mb-5 mr-[10px]"
          >
          <div #shakerPlotWrapper>
            <app-shaker-control-task-configuration
              [userSettingInput]="wrapper.input"
              (userSettingInputUpdate)="_onShakerProfileUpdate()"
              [requireOverride]="inputValueDiff[wrapper.key] !== undefined"
              [overrideDefaultValue]="inputValueDiff[wrapper.key]?.value ?? undefined"
              [overrideDefaultTemplateId]="inputValueDiff[wrapper.key]?.templateId ?? undefined"
              [readonly]="readonly" />
          </div>
          @if (loadingData) {
            <app-loading-overlay [targetElement]="shakerPlotWrapper">
              <app-spinner size="lg"></app-spinner>
            </app-loading-overlay>
          }
        </div>
      }
    }
  }
</ng-template>
